export default __webpack_public_path__ + "static/media/train.5663a128.jpg";